import { useState, useEffect, useMemo } from "react";

export function useTimeAgo(date) {
  const targetDate = useMemo(() => new Date(date), [date]);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => {
      const current = new Date();
      if (
        Math.floor((current - targetDate) / 60000) !==
        Math.floor((now - targetDate) / 60000)
      ) {
        setNow(current);
      }
    };
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [targetDate, now]);

  const timeAgo = useMemo(() => {
    let distance = Math.abs(now - targetDate);

    const hours = Math.floor(distance / 3600000);
    distance -= hours * 3600000;
    const minutes = Math.floor(distance / 60000);

    const days = Math.floor(hours / 24);
    const hrs = hours % 24;

    return days
      ? `${days} Days, ${hrs} Hrs, ${minutes} Min Ago`
      : hrs
      ? `${hrs} Hrs, ${minutes} Min Ago`
      : `${minutes} Min Ago`;
  }, [now, targetDate]);

  return timeAgo;
}
